import { Link } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

import styles from './Footer.module.css';

export function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <span className={styles.text}>
                {`\u00A9 ${currentYear} Qolca`}
            </span>
            <span className={styles.sep}>·</span>
            <Link to={ROUTES.privacy} className={styles.link}>Privacidad</Link>
            <span className={styles.sep}>·</span>
            <Link to={ROUTES.terms} className={styles.link}>Terminos</Link>
            <span className={styles.sep}>·</span>
            <a href="mailto:info@qolca.org" className={styles.link}>info@qolca.org</a>
        </footer>
    );
}
